<app-breadcrumb [title]="'Contratos'" [items]="['Extractos']" [active_item]="'Contratos'"></app-breadcrumb>
<div class="container-fluid">
<div class="card">
  <div class="card-header bg-primary">
    <h5 class="text-uppercase text-white"><strong><i class="icofont icofont-file-document me-2"></i>LISTADO DE CONTRATOS</strong></h5>
  </div>

  <div class="card-body custom-datatable noscroll">
     <div class="card-body">
    <form [formGroup]="formPlanilla">
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label" for="objeto"><strong>Objeto del contrato:</strong></label>
          <ng-select #inputObjeto id="objeto" [items]="objetos" bindLabel="descripcion" bindValue="id"
            [multiple]="true" [closeOnSelect]="false"
            placeholder="Selecciona una o más opciones" formControlName="objeto" class="js-example-placeholder-multiple">
          </ng-select>
        </div>
        <div class="col-md-3">
          <label class="form-label" for="contratista"><strong>Contratista:</strong></label>
          <ng-select #inputContratista id="contratista" [items]="empresas" bindLabel="nombre" bindValue="nit"
            placeholder="Selecciona contratista" formControlName="contratista" class="js-example-placeholder-multiple">
          </ng-select>
        </div>
          <div class="col-md-3">
            <label class="form-label" for="finicial"><strong>Fecha inicial:</strong></label>
            <div class="input-group input-group-sm">
              <input #inputInicial id="finicial" type="date" formControlName="finicial" class="form-control form-control-lg fs-14"
                (change)="actualizarMinFechaFinalFiltro()" [max]="hoy" onkeydown="return false;" />
            </div>
          </div>

        <div class="col-md-3">
          <label class="form-label" for="ffinal"><strong>Fecha final:</strong></label>
          <div class="input-group input-group-sm">
            <input #inputFinal id="ffinal" type="date" formControlName="ffinal" class="form-control form-control-lg fs-14"
              [min]="minFechaFinal" [max]="hoy" onkeydown="return false;" />
          </div>
        </div>
      </div>
    </form>
    <div class="card card-absolute border border-primary rounded my-5">
      <div class="card-header bg-primary">
        <h5 class="text-white"><strong>FILTROS RÁPIDOS</strong></h5>
      </div>
      <div class="card-body">
        <div class="row g-3 mb-3">
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100" (click)="seleccionarRango('dia')"><strong>AYER</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('semana')"><strong>ÚLTIMA SEMANA</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('mes')"><strong>MES</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('trimestre')"><strong>TRIMESTRE</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('semestre')"><strong>SEMESTRE</strong></button>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-primary btn-sm w-100"
              (click)="seleccionarRango('anio')"><strong>AÑO</strong></button>
          </div>

        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center gap-3 mt-3">
       <button class="btn btn-secondary"  type="button" (click)="limpiarFiltros()">
        <i class="icofont icofont-refresh"></i>
        LIMPIAR
      </button>
      <button class="btn btn-primary"  type="button" (click)="consultarContratos()">
        <i class="icofont icofont-search"></i>
        CONSULTAR
      </button>
      
    </div>
    <div *ngIf="mensajeBusqueda" class="alert alert-warning alert-dismissible fade show text-center mt-2" role="alert">
      <i class="fa fa-exclamation-triangle me-2"></i>
      <strong>{{ mensajeBusqueda }}</strong>
    </div>
    
      <!-- Buscador -->
      <div class="row mb-3">
        <div class="col-12 col-md-3 ms-auto">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Buscar..."
              [(ngModel)]="searchText"
              (input)="filterData()"
            />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>


    <div class="custom-datatable table-responsive my-4">
      <table class="table table-hover table-bordered" id="tblContratos">
        <thead class="bg-primary">
          <tr>
            <th class="text-center"><strong>CONTRATO N°</strong></th>
            <th class="text-center"><strong>NIT / CC</strong></th>
              <th class="text-center"><strong>CONTRATANTE</strong></th>
              
            <th class="text-center"><strong>INICIO</strong></th>
            <th class="text-center"><strong>FINAL</strong></th>
            <th class="text-center"><strong>OBJETO CONTRATO</strong></th>
            <th class="text-center"><strong>RESPONSABLE</strong></th>
            <th class="text-center"><strong>DISPONIBILIDAD TOTAL</strong></th>
            <th class="text-center"><strong>OPCIONES</strong></th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let contrato of filteredTableItems | paginate: { itemsPerPage: pageSize1, currentPage: page1 }"
            (click)="contratoSeleccionado = contrato">
            <td class="text-center">{{ contrato.numero }}</td>
            <td class="text-center">{{ contrato.cedula }}</td>
            <td class="text-center">{{ contrato.contratante }}</td>
            
            <td class="text-center">{{ contrato.inicio | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">{{ contrato.fin | date:'dd/MM/yyyy' }}</td>
            <td class="text-center">{{ contrato.objetoContrato.descripcion }}</td>
            <td class="text-center">{{ contrato.responsable }}</td>
            <td class="text-center">
              <span>{{ contrato.disponibilidad == 1 ? 'SI' : 'NO' }}</span>
            </td>

            <!-- Buscar tarjeta correspondiente -->
            <td>
              <div class="action text-center">
                <ul class="list-inline d-flex justify-content-center gap-3">
                  <li class="list-inline-item edit">
                    <a href="javascript:void(0)">
                      <i class="icon-pencil-alt" (click)="openModalContrato(modalContratos, contrato.id)" ngbTooltip="Editar"></i>
                    </a>
                  </li>
                  <li class="list-inline-item delete">
                    <a href="javascript:void(0)">
                      <i class="icon-trash" (click)="avisoInactivarContrato(contrato.id)" ngbTooltip="Inactivar"></i>
                    </a>
                  </li>
                  <li class="list-inline-item text-primary">
                    <a href="javascript:void(0)"
                      [class.disabled]="contrato.tipo !== 4"
                      [attr.aria-disabled]="contrato.tipo !== 4"
                      [style.pointer-events]="contrato.tipo !== 4 ? 'none' : 'auto'">
                      <i class="icon-file"
                        (click)="contrato.tipo === 4 && GenerarPdfDatosContrato(contrato.numero)"
                        placement="top"
                        ngbTooltip="Generar Ficha">
                      </i>
                    </a>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          <tr *ngIf="!filteredTableItems || filteredTableItems.length === 0">
            <td class="text-center" colspan="9">Sin datos</td>
          </tr>
        </tbody>
      </table>


    </div>
     <!-- Controles de paginación -->
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 gap-2">
        
        <!-- Selector registros -->
        <div class="d-flex align-items-center">
          <label for="pageSize1" class="me-2">Mostrar:</label>
          <select id="pageSize1" class="form-select form-select-sm w-auto" [(ngModel)]="pageSize1" (change)="page1 = 1">
            <option *ngFor="let size1 of [5,10, 20, 50, 100,1000]" [value]="size1">{{ size1 }}</option>
          </select>
          <span class="ms-2">registros</span>
        </div>

        <!-- Total registros -->
        <div class="text-center">
          <span class="badge bg-primary"><b>Total: {{ filteredTableItems?.length || 0 }}</b></span>
        </div>

        <!-- Paginador -->
        <div class="text-end">
          <pagination-controls
            (pageChange)="page1 = $event" 
            [maxSize]="5"
            [directionLinks]="true"
            [autoHide]="true"
            previousLabel="Anterior" 
            nextLabel="Siguiente">
          </pagination-controls>
        </div>
      </div>
    <div class="card-body">
      <div class="btn-showcase text-center">
        <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
          (click)="exportarExcel('tblContratos', 'Listado_contratos_Activos')">
          <i class="icofont icofont-file-excel"></i> EXCEL
        </button>
        <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar todos los contratos a PDF"
          (click)="GenerarPdfTodosContratos()">
          <i class="icofont icofont-file-pdf"></i> PDF
        </button>

        <button class="btn btn-primary" type="button" placement="top" ngbTooltip="Crear"
          (click)="openModalContrato(modalContratos)">
          <i class="icofont icofont-plus"></i> CREAR
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="filteredTableItems?.length > 0" class="row g-4 mb-4">

  <!-- TOTAL -->
  <div class="col-12 col-sm-6 col-xl-3 my-5">
    <div class="card stats-card total-card h-100 border-0">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
          
          <div>
            <p class="stats-title">TOTAL CONTRATOS</p>
            <h2 class="stats-number">
              {{ estadisticas.totalContratos }}
            </h2>
          </div>

          <div class="stats-icon bg-primary-subtle">
            <i class="icofont icofont-file-document text-primary"></i>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-6 col-xl-3 my-5">
    <div class="card stats-card total-card h-100 border-0 vigente-card ">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center ">
          
          <div>
            <p class="stats-title text-success">VIGENTES</p>
            <h2 class="stats-number">
              {{ estadisticas.contratosVigentes }}
            </h2>
          </div>

          <div class="stats-icon bg-success-subtle">
            <i class="icofont icofont-check text-success"></i>
          </div>

        </div>
      </div>
    </div>
  </div>
 
  <!-- VENCIDOS -->
     <div class="col-12 col-sm-6 col-xl-3 my-5">
    <div class="card stats-card total-card h-100 border-0 vencido-card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
          
          <div>
            <p class="stats-title">VENCIDOS</p>
            <h2 class="stats-number">
              {{ estadisticas.contratosVencidos }}
            </h2>
          </div>

          <div class="stats-icon bg-danger-subtle">
            <i class="icofont icofont-error text-danger"></i>
          </div>

        </div>
      </div>
    </div>
  </div>
    <div class="col-12 col-sm-6 col-xl-3 my-5">
    <div class="card stats-card total-card h-100 border-0 disponibilidad-card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center">
          
          <div>
            <p class="stats-title">DISPONIBILIDAD TOTAL</p>
            <h2 class="stats-number">
              {{ estadisticas.disponibilidadSi }}
            </h2>
          </div>

          <div class="stats-icon bg-primary-subtle">
            <i class="icofont icofont-file-document text-primary"></i>
          </div>

        </div>
      </div>
    </div>
  </div>
 

  <!-- DISPONIBILIDAD -->
 

</div>
</div>

</div>


<ng-template #myModal let-modal>
  <div class="card border-4 rounded-3">
    <div class="card-header bg-primary text-white d-flex justify-content-between align-items-center rounded-top">
      <h5 class="mb-0"><strong>CREACIÓN DE ENTIDADES / EMPRESAS</strong></h5>
    </div>
    <div class="modal-body">
      <form [formGroup]="formEmpresa">
        <!-- Inputs antes de la tabla -->
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label" for="nit"><strong>CC / NIT *:</strong></label>
            <input #inputNit class="form-control" id="nit" type="number" placeholder="Ingrese CC o NIT" required
              formControlName="nit" [class.is-invalid]="formEmpresa.get('nit')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('nombre')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un nombre.
            </div>

          </div>
          <div class="col-md-3">
            <label class="form-label" for="digito">
              <strong>Digito de Verificacción *:</strong></label>
            <input #inputCodigo class="form-control" id="digito" type="number" required
              placeholder="Ingrese el dígito de verificación" formControlName="digito"
              [class.is-invalid]="formEmpresa.get('digito')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('digito')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un digito de verificación.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="nombre"><strong>Nombre Completo/Razon Social *:</strong></label>
            <input #inputNombre class="form-control" id="nombre" type="text"
              placeholder="Ingrese el nombre o razon social" required formControlName="nombre"
              [class.is-invalid]="formEmpresa.get('nombre')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('nombre')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un número de documento.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="direccion">
              <strong>Dirección *:</strong></label>
            <input #inputDireccion class="form-control" id="direccion" type="text" required
              placeholder="Ingresa una dirección" formControlName="direccion"
              [class.is-invalid]="formEmpresa.get('direccion')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('direccion')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa una dirección.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label"><strong>Ciudad *:</strong></label>
            <ng-select #inputCiudad id="ciudad" [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
              placeholder="Selecciona una opción" formControlName="ciudad" required>
            </ng-select>
            <div *ngIf="formEmpresa.get('ciudad')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa una ciudad.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="telefono"><strong>Teléfono fijo:</strong></label>
            <input class="form-control" id="telefono" type="number" inputmode="numeric"
              placeholder="Ingresa el teléfono fijo" formControlName="telefono" maxlength="10" pattern="[0-9]*" />
          </div>
          <div class="col-md-3">
            <label class="form-label" for="celular"><strong>Teléfono celular *:</strong></label>
            <input #inputCelular class="form-control" id="celular" type="number" inputmode="numeric"
              placeholder="Ingresa el teléfono celular" formControlName="celular" required maxlength="10"
              pattern="[0-9]*" [class.is-invalid]="formEmpresa.get('celular')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('celular')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un número de celular.
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label" for="email">
              <strong>Correo electrónico:</strong></label>
            <input #inputEmail class="form-control" id="email" type="text" 
              placeholder="Ingresa un correo valido" formControlName="email"
              [class.is-invalid]="formEmpresa.get('email')?.invalid && validate" />
            <div *ngIf="formEmpresa.get('email')?.invalid && validate" class="invalid-feedback">
              Por favor, ingresa un correo electronico.
            </div>
          </div>

          <div class="row g-3 mb-3">
            <div class="mb-3">
              <label>Observaciones</label>
              <textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones"></textarea>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarEmpresa(modalEmpresaRef)">
        Guardar
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">
        Cancelar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modalContratos let-modal>
  <!-- Modal Header -->
  <div class="modal-header">
    <h5 class="modal-title">
      {{ editMode ? 'EDITAR CONTRATO - ID: ' + formContrato.get('id')?.value : 'CREAR CONTRATO' }}
    </h5>
    <button class="btn-close" type="button" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">
    <form class="form-bookmark needs-validation" novalidate>
      <!-- Placeholder row for validación o notificaciones futuras -->
      <div class="row"></div>
    </form>

    <!-- Acordeón de secciones -->
    <div class="card">
      <div class="col-12">
        <ngb-accordion [closeOthers]="true" [activeIds]="activePanelmodel" #accordion="ngbAccordion">

          <!-- Panel: Datos del Contratante -->
          <ngb-panel id="static-1">
            <ng-template ngbPanelTitle>
              <i class="fa fa-car"></i>
              <span class="ms-2" (click)="togglePanel('static-1')"><strong>DATOS DEL CONTRATANTE</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="card-body">
                <!-- Empresa seleccionada -->
                <div class="col-md-5 mb-3">
                  <label class="form-label"><strong>Contratante *:</strong></label>
                  <div class="input-group">
                    <ng-select #inputEmpresa
                      [items]="empresas"
                      bindLabel="nombre"
                      bindValue="nit"
                      placeholder="Selecciona una opción"
                      [(ngModel)]="empresaSeleccionada"
                      (change)="mostrarEmpresaSeleccionada()"
                      class="form-control p-0 border-0"
                      [attr.title]="empresaSeleccionada?.nombre">
                    </ng-select>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openModalEmpresa(myModal)" ngbTooltip="Crear empresa contratista">
                      <i class="icofont icofont-plus"></i>
                    </button>
                  </div>
                </div>

                <!-- Formulario datos contratante -->
                <form [formGroup]="formContrato">
                  <div class="row g-3 my-4">
                    <div class="col-md-6">
                      <label class="form-label"><strong>CC / NIT *:</strong></label>
                      <input class="form-control" type="number" placeholder="Ingrese CC o NIT" formControlName="cedula" readonly />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Contratista *:</strong></label>
                      <input class="form-control" type="text" placeholder="Nombre del contratista" formControlName="contratante" readonly />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Dirección *:</strong></label>
                      <input class="form-control" type="text" placeholder="Dirección" formControlName="direccion" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Ciudad *:</strong></label>
                      <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="MUNICIPIO" placeholder="Ciudad" formControlName="ciudad"></ng-select>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Teléfono *:</strong></label>
                      <input class="form-control" type="number" placeholder="Teléfono" formControlName="telefono" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Correo Electrónico: </strong></label>
                      <input class="form-control" type="text" placeholder="Correo electrónico" formControlName="mail" />
                    </div>
                  </div>
                </form>

                <!-- Botón para trasladar datos -->
                <div class="btn-showcase my-4">
                  <button class="btn btn-outline-primary" (click)="trasladarDatosEmpresa()">
                    Trasladar Datos a Responsable
                  </button>
                </div>
              </div>
            </ng-template>
          </ngb-panel>

          <!-- Panel: Datos del Responsable -->
          <ngb-panel id="static-2">
            <ng-template ngbPanelTitle>
              <i class="icofont icofont-id-card"></i>
              <span class="ms-2"><strong>DATOS DEL RESPONSABLE</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="card-body">
                <form [formGroup]="formContrato">
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label"><strong>CC / NIT *:</strong></label>
                      <input class="form-control" type="number" formControlName="idres" placeholder="Ingrese CC o NIT" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Responsable *:</strong></label>
                      <input class="form-control" type="text" formControlName="responsable" placeholder="Nombre o razón social" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Dirección *:</strong></label>
                      <input class="form-control" type="text" formControlName="dirresponsble" placeholder="Dirección" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Ciudad *:</strong></label>
                      <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="MUNICIPIO" formControlName="cuires" placeholder="Ciudad"></ng-select>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Teléfono *:</strong></label>
                      <input class="form-control" type="number" formControlName="telres" placeholder="Teléfono fijo" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Correo Electrónico</strong></label>
                      <input class="form-control" type="text" formControlName="mailresp" placeholder="Correo electrónico" />
                    </div>
                  </div>
                </form>
              </div>
            </ng-template>
          </ngb-panel>

          <!-- Panel: Datos del Contrato -->
          <ngb-panel id="static-3">
            <ng-template ngbPanelTitle>
              <i class="icofont icofont-id-card"></i>
              <span class="ms-2"><strong>DATOS DEL CONTRATO</strong></span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="card-body">
                <form [formGroup]="formContrato">
                  <div class="row g-3">
                    <div class="col-md-6">
                      <label class="form-label"><strong>Objeto del contrato *:</strong></label>
                      <ng-select [items]="objetos" bindLabel="descripcion" bindValue="id" formControlName="tipo" placeholder="Objeto del contrato"></ng-select>
                    </div>
                    <div class="col-md-6">
                  <label class="form-label"><strong>Disponibilidad Total *</strong></label>
                  <ng-select
                    [items]="[{ label: 'Sí', value: 1 }, { label: 'No', value: 0 }]"
                    bindLabel="label"
                    bindValue="value"
                    formControlName="disponibilidad"
                    (change)="onDisponibilidadChange($event?.value ?? $event)"
                    placeholder="Seleccione una opción">
                  </ng-select>
                </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Fecha inicial *:</strong></label>
                      <input type="date" class="form-control" formControlName="inicio" [min]="minDate" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Fecha final *:</strong></label>
                      <input type="date" class="form-control" formControlName="fin" [min]="fechaMinimaFinal" />
                    </div>
                  <div>
                    <div class="row" *ngIf="mostrarOrigenDestino">
                   <div class="col-md-6">
                      <label class="form-label"><strong>Origen *</strong></label>
                      <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN" placeholder="Selecciona una opción"
                        formControlName="origen">
                      </ng-select>
                    </div>
                    
                    <div class="col-md-6">
                      <label class="form-label"><strong>Destino *</strong></label>
                      <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN" placeholder="Selecciona una opción"
                        formControlName="destino">
                      </ng-select>
                    </div>
                    
                    </div>
                  
                    </div>                   <div class="col-md-6">
                      <label class="form-label"><strong>Pasajeros:</strong></label>
                      <input class="form-control" type="number" formControlName="pasajeros" placeholder="Cantidad de pasajeros" />
                    </div>
                    <div class="col-md-6">
                      <label class="form-label"><strong>Valor del servicio:</strong></label>
                      <input class="form-control" type="number" formControlName="valor" placeholder="Valor" />
                    </div>
                   
                                  </div>
                </form>
              </div>
            </ng-template>
          </ngb-panel>

        </ngb-accordion>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="guardarContrato(modalContratoRef)">
        {{ editMode ? 'Actualizar' : 'Crear' }} Contrato
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    </div>
  </div>
</ng-template>
